import { render, staticRenderFns } from "./AlertOverwriteDialog.vue?vue&type=template&id=90c56b1c&scoped=true&"
import script from "./AlertOverwriteDialog.vue?vue&type=script&lang=js&"
export * from "./AlertOverwriteDialog.vue?vue&type=script&lang=js&"
import style0 from "./AlertOverwriteDialog.vue?vue&type=style&index=0&id=90c56b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c56b1c",
  null
  
)

export default component.exports